import type {CommonDescriptionAttribute} from '../types/CommonDescriptionAttribute';
import type {CommonFinancingPriceAttribute} from '../types/CommonFinancingPriceAttribute';
import type {CommonMileageAttribute} from '../types/CommonMileageAttribute';
import type {CommonPriceAttribute} from '../types/CommonPriceAttribute';
import type {CommonPriceNoteAttribute} from '../types/CommonPriceNoteAttribute';
import type {CommonTitleExtensionAttribute} from '../types/CommonTitleExtensionAttribute';
import type {WindshieldContactEmailAttribute} from '../types/WindshieldContactEmailAttribute';
import type {WindshieldContactPhoneAttribute} from '../types/WindshieldContactPhoneAttribute';

export type VehicleWindshieldAdvertisingAttributeRequestBody =
  | CommonTitleExtensionAttribute
  | CommonMileageAttribute
  | WindshieldContactEmailAttribute
  | WindshieldContactPhoneAttribute
  | CommonDescriptionAttribute
  | CommonPriceAttribute
  | CommonFinancingPriceAttribute
  | CommonPriceNoteAttribute;
